export default {
  API_URL: 'https://engie-api.cometrootapp.com/api/',
  SANDBOX_URL: 'https://engiesandbox-api.cometrootapp.com/api/'
  // API_URL: 'https://localhost:44365/api',
  // SANDBOX_URL: 'https://localhost:44365/api'
}
